require('../../modules/es6.date.now');
module.exports = require('../../modules/_core').Date.now;



//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/~/core-js/library/fn/date/now.js
// module id = 1150
// module chunks = 0